import { Box, Flex, Text } from '@chakra-ui/react';

import { SchemaStep } from './encodeDecodeAnswers';

type MarketplaceConditionProgressProps = {
  steps: SchemaStep[];
  currentStep: number;
  isOnDone: boolean;
  timeEstimate?: string;
};

const MarketplaceConditionProgress = ({
  steps,
  currentStep,
  isOnDone,
  timeEstimate,
}: MarketplaceConditionProgressProps) => {
  const currentLabel = steps[currentStep]?.stepLabel;

  return (
    <Box>
      <Flex gap="4px" mb="6px">
        {steps.map((step, i) => {
          const done = isOnDone || i < currentStep;
          const active = !isOnDone && i === currentStep;
          return (
            <Box
              key={step.stepId}
              flex={1}
              h="4px"
              borderRadius="2px"
              bg={done ? 'leaseEndGreen' : active ? 'oceanBoatBlue' : 'gray.200'}
            />
          );
        })}
      </Flex>
      <Flex align="baseline" justify="space-between" gap={2}>
        <Text fontSize="xs" fontWeight="600" color={isOnDone ? 'leaseEndGreen' : 'grayLight'}>
          {isOnDone ? (
            'Complete'
          ) : (
            <>
              Step {currentStep + 1} of {steps.length}
              {currentLabel && (
                <Text as="span" color="grayDark">
                  {' · '}
                  {currentLabel}
                </Text>
              )}
            </>
          )}
        </Text>
        {timeEstimate && !isOnDone && (
          <Text fontSize="xs" color="grayLight">
            {timeEstimate}
          </Text>
        )}
      </Flex>
    </Box>
  );
};

export default MarketplaceConditionProgress;
